import React from "react";
import {
  Grid,
} from "@mui/material";
import { InstanceEncodingDTO } from "./types";

export default function InstanceEncodingTableRow (entry: InstanceEncodingDTO, bold = false) {
  const {method, metadataKey, metadataValue} = entry;
  return (
    <>
      <Grid item xs={1}/>
      <Grid item xs={4} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {method}
      </Grid>
      <Grid item xs={3} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {metadataKey}
      </Grid>
      <Grid item xs={3} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {metadataValue}
      </Grid>
      <Grid item xs={1}/>
    </>
  );
}